import React, { FC, ComponentType, CSSProperties } from 'react';
import { Button, ButtonProps, SvgIconProps } from '@material-ui/core';
import { createStyles, Theme, WithStyles, withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';

const styles = (theme: Theme) =>
  createStyles({
    button: {
      display: 'flex',
      justifyContent: 'flex-start',
      fontWeight: theme.typography.fontWeightBold,
      backgroundColor: theme.palette.common.white,
      color: theme.custom.palette.black1,
      border: `1px solid ${theme.custom.palette.grey3}`,

      '&:hover, &:active': {
        backgroundColor: theme.palette.common.white,
        color: theme.custom.palette.black1,
        boxShadow: 'none',
      },
    },
    left: {
      marginRight: theme.spacing(1),
    },
    right: {
      marginLeft: theme.spacing(1),
    },
    green: {
      color: theme.palette.secondary.main,
    },
    red: {
      color: theme.palette.error.main,
    },
  });

interface IProps extends WithStyles<typeof styles> {
  ButtonProps: ButtonProps;
  icon: ComponentType<SvgIconProps>;
  iconClassName?: string;
  iconStyle?: CSSProperties;
  className?: string;
  color?: 'green' | 'red';
  align?: 'left' | 'right';
}

const IconLabelButton: FC<IProps> = props => {
  const { align, classes, className, children, color, icon, iconStyle, iconClassName } = props;
  const buttonClasses = classNames(classes.button, className);
  const iconClasses = classNames(classes[align], classes[color], iconClassName);

  const PassedIcon = icon;
  const renderedIcon = <PassedIcon style={iconStyle} className={iconClasses} />;

  return (
    <Button fullWidth variant="contained" className={buttonClasses} {...props.ButtonProps}>
      {align === 'left' && renderedIcon}
      {children}
      {align === 'right' && renderedIcon}
    </Button>
  );
};

IconLabelButton.defaultProps = {
  iconClassName: '',
  iconStyle: {},
  color: 'green',
  align: 'left',
};

export default withStyles(styles)(IconLabelButton);
